import { render, staticRenderFns } from "./SazitoIntegrator.vue?vue&type=template&id=7ba5ae47&scoped=true&"
import script from "./SazitoIntegrator.vue?vue&type=script&lang=js&"
export * from "./SazitoIntegrator.vue?vue&type=script&lang=js&"
import style0 from "./SazitoIntegrator.vue?vue&type=style&index=0&id=7ba5ae47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba5ae47",
  null
  
)

export default component.exports